import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const trainingsData = [
  {
    id: 1,
    category: 'İlkyardım',
    title: 'Adana Temel İlkyardım Eğitimi',
    description: 'Adana\'da Sağlık Bakanlığı onaylı temel ilkyardım eğitimi ile çalışanlarınızı acil durumlara hazırlayın. Adana Seyhan, Çukurova, Yüreğir ve tüm ilçelerde geçerli sertifika. Kalp masajı, suni solunum, kanamalarda müdahale ve kırık-çıkık müdahale teknikleri. Adana OSB ve sanayi bölgelerindeki iş yerlerine özel kurumsal eğitim seçenekleri.',
    duration: '16 Saat',
    certificate: 'Sağlık Bakanlığı Onaylı',
    image: 'https://public.readdy.ai/ai/img_res/5f85136da7ea5f6e18e4dd7440f1ec0e.jpg',
    keywords: 'Adana ilkyardım eğitimi, Adana ilkyardım kursu, Adana sertifikalı ilkyardım'
  },
  {
    id: 2,
    category: 'İlkyardım',
    title: 'Adana İlkyardım Güncelleme Eğitimi',
    description: 'Adana\'da ilkyardımcı belgenizin süresi dolmak üzere mi? Güncelleme eğitimimiz ile bilgilerinizi tazeleyin ve sertifikanızı yenileyin. Adana genelinde kabul edilen güncel protokoller ve yeni müdahale teknikleri. Adana Organize Sanayi Bölgesi, Hacı Sabancı OSB ve tüm fabrikalar için geçerli belge yenileme.',
    duration: '8 Saat',
    certificate: 'Sağlık Bakanlığı Onaylı',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20medical%20training%20refresher%20course%20with%20experienced%20instructor%20demonstrating%20modern%20emergency%20response%20techniques%20to%20healthcare%20professionals%20in%20bright%20contemporary%20training%20facility%20with%20updated%20medical%20equipment&width=400&height=250&seq=t2&orientation=landscape',
    keywords: 'Adana ilkyardım güncelleme, Adana ilkyardım sertifika yenileme'
  },
  {
    id: 3,
    category: 'İş Güvenliği',
    title: 'Adana Yüksekte Çalışma Eğitimi',
    description: 'Adana\'da IRATA Level 3 sertifikalı eğitmenlerimiz ile yüksekte çalışma riskleri ve güvenlik önlemleri hakkında kapsamlı eğitim. Adana inşaat sektörü, fabrika bakım onarım çalışmaları ve yüksek yapı işleri için zorunlu eğitim. Emniyet kemeri kullanımı, düşme önleme sistemleri, iskele güvenliği ve kurtarma teknikleri. Adana İSG mevzuatına tam uyumlu.',
    duration: '8 Saat',
    certificate: 'İSG Sertifikası',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20height%20safety%20training%20with%20workers%20wearing%20harnesses%20and%20safety%20equipment%20on%20scaffolding%20structure%20professional%20occupational%20safety%20training%20scene%20with%20blue%20sky%20background%20construction%20environment&width=400&height=250&seq=t3&orientation=landscape',
    keywords: 'Adana yüksekte çalışma eğitimi, Adana iş güvenliği eğitimi'
  },
  {
    id: 4,
    category: 'Acil Durum',
    title: 'Adana Yangın Güvenliği Eğitimi',
    description: 'Adana\'da yangın güvenliği ve acil tahliye eğitimi ile iş yerinizi güvende tutun. Adana Sanayi Bölgesi, OSB ve fabrikalar için özel yangın tatbikatı uygulamaları. Yangın söndürücü kullanımı, tahliye planları, yangın türleri ve müdahale yöntemleri. Adana İtfaiye Müdürlüğü standartlarına uygun eğitim programı.',
    duration: '4 Saat',
    certificate: 'İSG Sertifikası',
    image: 'https://readdy.ai/api/search-image?query=Fire%20safety%20training%20with%20fire%20extinguisher%20demonstration%20and%20controlled%20flames%20in%20professional%20training%20facility%20firefighters%20and%20safety%20equipment%20orange%20flames%20against%20dark%20background%20dramatic%20lighting&width=400&height=250&seq=t4&orientation=landscape',
    keywords: 'Adana yangın eğitimi, Adana yangın güvenliği, Adana acil durum eğitimi'
  },
  {
    id: 5,
    category: 'Sağlık',
    title: 'Adana Hijyen Eğitimi',
    description: 'Adana\'da gıda işletmeleri ve sağlık sektörü için zorunlu hijyen eğitimi. Adana restoranları, otelleri, hastaneleri ve gıda üretim tesisleri için HACCP standartlarına uygun eğitim. Kişisel hijyen, gıda güvenliği, temizlik ve dezenfeksiyon protokolleri. Adana Halk Sağlığı Müdürlüğü onaylı sertifika programı.',
    duration: '8 Saat',
    certificate: 'HACCP Sertifikası',
    image: 'https://readdy.ai/api/search-image?query=Professional%20hygiene%20training%20in%20food%20industry%20setting%20with%20workers%20in%20white%20uniforms%20and%20hairnets%20demonstrating%20proper%20hand%20washing%20and%20sanitation%20procedures%20clean%20modern%20kitchen%20environment&width=400&height=250&seq=t5&orientation=landscape',
    keywords: 'Adana hijyen eğitimi, Adana gıda güvenliği eğitimi, Adana HACCP'
  },
  {
    id: 6,
    category: 'MYK',
    title: 'Adana Mesleki Yeterlilik Eğitimleri',
    description: 'Adana\'da MYK onaylı mesleki yeterlilik eğitimleri. Adana forklift eğitimi, vinç operatörlüğü, iş makineleri operatörlüğü ve daha fazlası. Teorik ve uygulamalı eğitim ile Adana\'da E-Devlet üzerinden sorgulanabilir MYK belgesi. Adana OSB, Hacı Sabancı OSB ve sanayi bölgelerindeki firmalar için kurumsal eğitim paketleri.',
    duration: '40 Saat',
    certificate: 'MYK Belgesi',
    image: 'https://readdy.ai/api/search-image?query=Vocational%20training%20center%20with%20forklift%20operation%20and%20industrial%20machinery%20training%20professional%20certification%20course%20with%20workers%20in%20safety%20vests%20and%20helmets%20warehouse%20environment%20with%20equipment&width=400&height=250&seq=t6&orientation=landscape',
    keywords: 'Adana MYK belgesi, Adana forklift eğitimi, Adana iş makinesi eğitimi'
  }
];

const sliderData = [
  {
    id: 1,
    title: 'Temel İlkyardım Eğitimi',
    subtitle: 'Sağlık Bakanlığı Onaylı',
    description: 'Acil durumlarda hayat kurtaran müdahale tekniklerini öğrenin. 16 saatlik kapsamlı eğitim programı.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20emergency%20medical%20training%20scene%20with%20instructor%20demonstrating%20CPR%20technique%20on%20mannequin%20modern%20bright%20training%20facility%20with%20medical%20equipment%20and%20first%20aid%20supplies%20warm%20lighting%20clean%20environment&width=1200&height=500&seq=slider1&orientation=landscape',
    badge: 'En Popüler'
  },
  {
    id: 2,
    title: 'Yüksekte Çalışma Eğitimi',
    subtitle: 'IRATA Sertifikalı Eğitmenler',
    description: 'İş güvenliği standartlarına uygun, uygulamalı yüksekte çalışma eğitimi.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20safety%20training%20at%20height%20with%20workers%20in%20safety%20harnesses%20and%20helmets%20on%20modern%20scaffolding%20structure%20professional%20occupational%20health%20training%20bright%20daylight%20blue%20sky%20background&width=1200&height=500&seq=slider2&orientation=landscape',
    badge: 'Yeni'
  },
  {
    id: 3,
    title: 'Yangın Güvenliği Eğitimi',
    subtitle: 'Acil Durum Müdahale',
    description: 'Yangın söndürme teknikleri ve tahliye prosedürleri hakkında kapsamlı eğitim.',
    image: 'https://readdy.ai/api/search-image?query=Fire%20safety%20training%20demonstration%20with%20professional%20firefighter%20using%20fire%20extinguisher%20on%20controlled%20flames%20in%20modern%20training%20facility%20dramatic%20orange%20fire%20against%20dark%20background%20safety%20equipment%20visible&width=1200&height=500&seq=slider3&orientation=landscape',
    badge: 'Zorunlu'
  },
  {
    id: 4,
    title: 'Mesleki Yeterlilik Eğitimleri',
    subtitle: 'E-Devlet Onaylı Belge',
    description: 'MYK onaylı mesleki yeterlilik eğitimleri ile profesyonel sertifika kazanın. Forklift, vinç ve iş makineleri operatörlüğü.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20vocational%20training%20center%20with%20multiple%20industrial%20machinery%20and%20equipment%20workers%20in%20safety%20gear%20learning%20various%20technical%20skills%20modern%20training%20facility%20with%20certification%20programs&width=1200&height=500&seq=slider4myk&orientation=landscape',
    badge: 'MYK Belgeli'
  }
];

const categories = ['Tümü', 'İlkyardım', 'İş Güvenliği', 'Acil Durum', 'Sağlık', 'MYK'];

const faqData = [
  {
    question: 'İlkyardım eğitimi kaç saat sürüyor?',
    answer: 'Temel ilkyardım eğitimi Sağlık Bakanlığı yönetmeliğine göre 16 saat sürmektedir. Güncelleme eğitimi ise 8 saattir. Eğitimler teorik ve uygulamalı olarak gerçekleştirilir.'
  },
  {
    question: 'İlkyardım sertifikası ne kadar süre geçerli?',
    answer: 'İlkyardımcı sertifikası 3 yıl süreyle geçerlidir. Süre dolmadan önce 8 saatlik güncelleme eğitimi alarak sertifikanızı yenileyebilirsiniz.'
  },
  {
    question: 'İş yerinde kaç kişi ilkyardımcı olmak zorunda?',
    answer: 'İş Sağlığı ve Güvenliği Kanunu\'na göre az tehlikeli işyerlerinde her 20 çalışan için 1, tehlikeli işyerlerinde her 15 çalışan için 1, çok tehlikeli işyerlerinde her 10 çalışan için 1 ilkyardımcı bulunması zorunludur.'
  },
  {
    question: 'Kurumsal eğitim alabilir miyiz?',
    answer: 'Evet, şirketinize özel kurumsal ilkyardım ve iş güvenliği eğitimleri düzenliyoruz. Toplu eğitimlerde özel fiyatlandırma avantajlarından yararlanabilirsiniz.'
  },
  {
    question: 'MYK belgesi nedir ve neden önemlidir?',
    answer: 'MYK (Mesleki Yeterlilik Kurumu) belgesi, belirli mesleklerde çalışanların yetkinliğini belgeleyen resmi bir sertifikadır. E-Devlet üzerinden sorgulanabilir ve birçok sektörde zorunludur.'
  },
  {
    question: 'Eğitim ücretleri ne kadar?',
    answer: 'Eğitim ücretleri program türüne ve katılımcı sayısına göre değişmektedir. Güncel fiyat bilgisi için 0850 346 2772 numaralı telefondan bize ulaşabilirsiniz.'
  }
];

export default function Trainings() {
  const [activeCategory, setActiveCategory] = useState('Tümü');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % sliderData.length);
  }, []);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + sliderData.length) % sliderData.length);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 5000);
  };

  useEffect(() => {
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    document.title = 'Adana İlkyardım ve İş Güvenliği Eğitimleri | Sertifikalı Eğitim Programları';
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const interval = setInterval(nextSlide, 4000);
    return () => clearInterval(interval);
  }, [isAutoPlaying, nextSlide]);

  const filteredTrainings = activeCategory === 'Tümü' 
    ? trainingsData 
    : trainingsData.filter(t => t.category === activeCategory);

  return (
    <div className="min-h-screen bg-[#f8f9fa] overflow-y-auto">
      {/* Navigation */}
      <header>
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'}`} aria-label="Ana navigasyon">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between py-6">
              <Link to="/">
                <img 
                  src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/6b24d68bdeb9b34d218f93fb0e94b90c.png" 
                  alt="Adana İlkyardım Eğitim Merkezi Logo" 
                  title="Adana İlkyardım Eğitim Merkezi"
                  className="h-40 w-auto object-contain"
                />
              </Link>
              <ul className="flex gap-8 list-none">
                <li><Link to="/" className={`text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>Ana Sayfa</Link></li>
                <li><Link to="/egitimler" className="text-[#ecad29] text-sm font-medium uppercase tracking-wide relative pb-2 cursor-pointer after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[3px] after:bg-[#ecad29] after:rounded">Eğitimler</Link></li>
                <li><Link to="/iletisim" className={`text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>İletişim</Link></li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <main>
        {/* Hero Slider Section */}
        <section className="relative overflow-hidden" aria-label="Öne çıkan eğitimler">
          <div className="relative h-[500px] w-full">
            {/* Slides */}
            {sliderData.map((slide, index) => (
              <article
                key={slide.id}
                className={`absolute inset-0 transition-all duration-700 ease-in-out ${
                  index === currentSlide 
                    ? 'opacity-100 translate-x-0 z-10' 
                    : index < currentSlide 
                      ? 'opacity-0 -translate-x-full z-0' 
                      : 'opacity-0 translate-x-full z-0'
                }`}
              >
                {/* Background Image */}
                <div className="absolute inset-0">
                  <img 
                    src={slide.image}
                    alt={`${slide.title} - Adana ${slide.subtitle}`}
                    title={`Adana ${slide.title}`}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
                </div>
                
                {/* Content */}
                <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
                  <div className="max-w-xl">
                    <span className="inline-block px-4 py-1.5 bg-[#ecad29] text-white text-xs font-bold rounded-full mb-4 animate-pulse">
                      {slide.badge}
                    </span>
                    <p className="text-[#ecad29] text-sm font-medium mb-2 tracking-wider uppercase">
                      {slide.subtitle}
                    </p>
                    <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4 font-['Oswald'] leading-tight">
                      {slide.title}
                    </h2>
                    <p className="text-gray-200 text-lg mb-8 leading-relaxed">
                      {slide.description}
                    </p>
                    <Link 
                      to="/iletisim"
                      className="inline-flex items-center gap-2 px-8 py-3 bg-[#ecad29] text-white rounded-full font-medium hover:bg-[#d49a1f] transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-[#ecad29]/30"
                    >
                      <span>Hemen Başvur</span>
                      <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
                    </Link>
                  </div>
                </div>
              </article>
            ))}

            {/* Navigation Arrows */}
            <button 
              onClick={() => { prevSlide(); setIsAutoPlaying(false); setTimeout(() => setIsAutoPlaying(true), 5000); }}
              className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm text-white rounded-full hover:bg-white/40 transition-all cursor-pointer group"
              aria-label="Önceki slayt"
            >
              <i className="ri-arrow-left-s-line text-2xl group-hover:scale-110 transition-transform"></i>
            </button>
            <button 
              onClick={() => { nextSlide(); setIsAutoPlaying(false); setTimeout(() => setIsAutoPlaying(true), 5000); }}
              className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm text-white rounded-full hover:bg-white/40 transition-all cursor-pointer group"
              aria-label="Sonraki slayt"
            >
              <i className="ri-arrow-right-s-line text-2xl group-hover:scale-110 transition-transform"></i>
            </button>

            {/* Dots Navigation */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3" role="tablist" aria-label="Slayt navigasyonu">
              {sliderData.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`transition-all cursor-pointer ${
                    index === currentSlide 
                      ? 'w-8 h-3 bg-[#ecad29] rounded-full' 
                      : 'w-3 h-3 bg-white/50 rounded-full hover:bg-white/80'
                  }`}
                  role="tab"
                  aria-selected={index === currentSlide}
                  aria-label={`Slayt ${index + 1}`}
                />
              ))}
            </div>

            {/* Progress Bar */}
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-black/20 z-20" aria-hidden="true">
              <div 
                className="h-full bg-[#ecad29] transition-all duration-300"
                style={{ width: `${((currentSlide + 1) / sliderData.length) * 100}%` }}
              />
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-8 bg-white border-b" aria-label="İstatistikler">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#ecad29] font-['Oswald']">5000+</div>
                <div className="text-sm text-gray-600">Mezun Öğrenci</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#ecad29] font-['Oswald']">15+</div>
                <div className="text-sm text-gray-600">Eğitim Programı</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#ecad29] font-['Oswald']">%98</div>
                <div className="text-sm text-gray-600">Memnuniyet Oranı</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#ecad29] font-['Oswald']">10+</div>
                <div className="text-sm text-gray-600">Yıllık Deneyim</div>
              </div>
            </div>
          </div>
        </section>

        {/* Filter Section */}
        <section className="py-8 px-4 sm:px-6 lg:px-8 bg-white border-b sticky top-20 z-40" aria-label="Eğitim kategorileri">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-wrap items-center gap-3" role="tablist">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeCategory === cat
                      ? 'bg-[#ecad29] text-white shadow-lg shadow-[#ecad29]/30'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  role="tab"
                  aria-selected={activeCategory === cat}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Trainings Grid */}
        <section className="py-16 px-4 sm:px-6 lg:px-8" aria-label="Eğitim programları listesi">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 font-['Oswald'] mb-3">
                <a href="#egitimler" className="hover:text-[#ecad29] transition-colors">
                  ADANA <span className="text-[#ecad29]">EĞİTİM PROGRAMLARI</span>
                </a>
              </h2>
              <p className="text-gray-600">Adana'da kariyer hedeflerinize uygun <strong>sertifikalı eğitimi</strong> seçin</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" id="egitimler">
              {filteredTrainings.map((training) => (
                <article 
                  key={training.id}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer group"
                >
                  <div className="relative h-[200px] w-full overflow-hidden">
                    <img 
                      src={training.image}
                      alt={`${training.title} - ${training.certificate}`}
                      title={training.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <span className="absolute top-4 right-4 px-3 py-1 bg-[#ecad29] text-white text-xs font-medium rounded-full">
                      {training.category}
                    </span>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      <a href="/iletisim" className="hover:text-[#ecad29] transition-colors">{training.title}</a>
                    </h3>
                    <p className="text-gray-600 text-sm mb-4 line-clamp-4">{training.description}</p>
                    
                    <div className="flex flex-wrap gap-4 mb-4 text-sm text-gray-500">
                      <div className="flex items-center gap-1">
                        <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                        <span>{training.duration}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <i className="ri-award-line w-4 h-4 flex items-center justify-center"></i>
                        <span>{training.certificate}</span>
                      </div>
                    </div>
                    
                    <div className="pt-4 border-t border-gray-100">
                      <Link 
                        to="/iletisim"
                        className="w-full inline-flex items-center justify-center px-4 py-2 border-2 border-[#ecad29] text-[#ecad29] rounded-full text-sm font-medium hover:bg-[#ecad29] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                      >
                        Detaylı Bilgi
                      </Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* SEO Content Section - Why Adana Training */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" aria-label="Adana'da ilkyardım eğitimi neden önemli">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <span className="inline-block px-4 py-2 bg-[#ecad29]/10 rounded-full mb-4">
                  <span className="text-[#ecad29] text-sm font-medium">Adana'da Eğitim</span>
                </span>
                <h3 className="text-3xl font-bold text-gray-900 font-['Oswald'] mb-6">
                  <a href="#adana-egitim" id="adana-egitim" className="hover:text-[#ecad29] transition-colors">
                    ADANA'DA İLKYARDIM EĞİTİMİ <span className="text-[#ecad29]">NEDEN ÖNEMLİ?</span>
                  </a>
                </h3>
                <div className="space-y-4 text-gray-600 leading-relaxed">
                  <p>
                    <strong>Adana</strong>, Türkiye'nin en büyük sanayi şehirlerinden biri olarak <strong>Adana Organize Sanayi Bölgesi</strong>, <strong>Hacı Sabancı OSB</strong> ve çok sayıda fabrika ile iş gücü yoğunluğu açısından kritik bir konumdadır. Bu nedenle <strong>Adana ilkyardım eğitimi</strong> ve <strong>Adana iş güvenliği eğitimi</strong> zorunlu hale gelmiştir.
                  </p>
                  <p>
                    <strong>Adana'da ilkyardım kursu</strong> almak, İş Sağlığı ve Güvenliği Kanunu gereği zorunludur. Özellikle <strong>Adana Seyhan</strong>, <strong>Çukurova</strong>, <strong>Yüreğir</strong>, <strong>Sarıçam</strong> ve <strong>Ceyhan</strong> ilçelerindeki sanayi tesislerinde çalışan personelin mutlaka <strong>Adana sertifikalı ilkyardım eğitimi</strong> alması gerekmektedir.
                  </p>
                  <p>
                    Eğitim merkezimiz, <strong>Adana Sağlık Bakanlığı onaylı ilkyardım eğitimi</strong> veren resmi kuruluşlar arasındadır. <strong>Adana yangın eğitimi</strong>, <strong>Adana yüksekte çalışma eğitimi</strong>, <strong>Adana hijyen eğitimi</strong> ve <strong>Adana MYK belgesi</strong> programlarımız ile iş yerlerinizi güvende tutuyoruz.
                  </p>
                </div>
              </div>
              <div className="relative h-[400px] w-full rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20training%20facility%20in%20Adana%20Turkey%20with%20professional%20first%20aid%20and%20occupational%20safety%20training%20classroom%20bright%20spacious%20room%20with%20medical%20equipment%20and%20safety%20gear%20industrial%20training%20center&width=600&height=400&seq=adana-training-center&orientation=landscape"
                  alt="Adana İlkyardım Eğitim Merkezi - Modern eğitim salonu"
                  title="Adana'da İlkyardım Eğitimi"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Advantages Section */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#f8f9fa]" aria-label="Adana ilkyardım eğitim merkezi avantajları">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 font-['Oswald'] mb-3">
                <a href="#avantajlar" id="avantajlar" className="hover:text-[#ecad29] transition-colors">
                  ADANA İLKYARDIM EĞİTİM MERKEZİ <span className="text-[#ecad29]">AVANTAJLARI</span>
                </a>
              </h3>
              <p className="text-gray-600">Neden <strong>Adana'da ilkyardım eğitimi</strong> için bizi tercih etmelisiniz?</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <article className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-[#ecad29]/10 rounded-full mb-6">
                  <i className="ri-government-line text-3xl text-[#ecad29]"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">
                  <a href="/iletisim" className="hover:text-[#ecad29] transition-colors">Resmi Onaylı Sertifikalar</a>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  <strong>Adana Sağlık Bakanlığı</strong> ve <strong>MYK onaylı</strong> sertifikalarımız tüm Türkiye'de geçerlidir. E-Devlet üzerinden sorgulanabilir belgeler.
                </p>
              </article>

              <article className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-[#ecad29]/10 rounded-full mb-6">
                  <i className="ri-map-pin-line text-3xl text-[#ecad29]"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">
                  <a href="/iletisim" className="hover:text-[#ecad29] transition-colors">Adana Merkezi Konum</a>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  <strong>Adana Seyhan</strong> merkezinde, <strong>Adana OSB</strong> ve <strong>Hacı Sabancı OSB</strong>'ye yakın konumumuz ile kolay ulaşım imkanı.
                </p>
              </article>

              <article className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-[#ecad29]/10 rounded-full mb-6">
                  <i className="ri-team-line text-3xl text-[#ecad29]"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">
                  <a href="/iletisim" className="hover:text-[#ecad29] transition-colors">Deneyimli Eğitmenler</a>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  IRATA Level 3 ve Sağlık Bakanlığı sertifikalı eğitmenlerimiz ile <strong>Adana'da kaliteli ilkyardım eğitimi</strong>.
                </p>
              </article>

              <article className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-[#ecad29]/10 rounded-full mb-6">
                  <i className="ri-hand-heart-line text-3xl text-[#ecad29]"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">
                  <a href="/iletisim" className="hover:text-[#ecad29] transition-colors">Uygulamalı Eğitim</a>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  Teorik bilginin yanında gerçek senaryolarla uygulamalı <strong>Adana ilkyardım kursu</strong>. Maket ve simülasyon ekipmanları.
                </p>
              </article>

              <article className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-[#ecad29]/10 rounded-full mb-6">
                  <i className="ri-building-line text-3xl text-[#ecad29]"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">
                  <a href="/iletisim" className="hover:text-[#ecad29] transition-colors">Kurumsal Eğitim Paketleri</a>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  <strong>Adana sanayi bölgeleri</strong>, fabrikalar ve OSB'lerdeki firmalar için özel kurumsal eğitim çözümleri ve toplu indirimler.
                </p>
              </article>

              <article className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
                <div className="w-16 h-16 flex items-center justify-center bg-[#ecad29]/10 rounded-full mb-6">
                  <i className="ri-calendar-check-line text-3xl text-[#ecad29]"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">
                  <a href="/iletisim" className="hover:text-[#ecad29] transition-colors">Esnek Eğitim Saatleri</a>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  Hafta içi ve hafta sonu eğitim seçenekleri. <strong>Adana'da ilkyardım eğitimi</strong> için size uygun zaman dilimini seçin.
                </p>
              </article>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#1a1a1a]" aria-label="Kurumsal eğitim">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-white mb-4 font-['Oswald']">
              <a href="/iletisim" className="hover:text-[#ecad29] transition-colors">
                KURUMSAL EĞİTİM <span className="text-[#ecad29]">ÇÖZÜMLERİ</span>
              </a>
            </h3>
            <p className="text-gray-400 mb-8">
              Şirketinize özel <strong>Adana ilkyardım eğitimi</strong> ve <strong>iş güvenliği programları</strong> için bizimle iletişime geçin. Toplu eğitimlerde özel fiyatlandırma avantajlarından yararlanın.
            </p>
            <Link 
              to="/iletisim"
              className="inline-flex items-center gap-2 px-8 py-3 bg-[#ecad29] text-white rounded-full font-medium hover:bg-[#d49a1f] transition-colors whitespace-nowrap cursor-pointer"
            >
              <span>Teklif Alın</span>
              <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
            </Link>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" aria-label="Sık sorulan sorular">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-2 bg-[#ecad29]/10 rounded-full mb-4">
                <span className="text-[#ecad29] text-sm font-medium">Merak Edilenler</span>
              </span>
              <h3 className="text-3xl font-bold text-gray-900 font-['Oswald'] mb-3">
                <a href="#sss" id="sss" className="hover:text-[#ecad29] transition-colors">
                  SIK SORULAN <span className="text-[#ecad29]">SORULAR</span>
                </a>
              </h3>
              <p className="text-gray-600">Adana ilkyardım eğitimi hakkında en çok merak edilen sorular ve cevapları</p>
            </div>
            
            <div className="space-y-4">
              {faqData.map((faq, index) => (
                <article 
                  key={index}
                  className="bg-[#f8f9fa] rounded-xl overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-100 transition-colors"
                    aria-expanded={openFaq === index}
                  >
                    <h4 className="text-base font-semibold text-gray-900 pr-4">{faq.question}</h4>
                    <div className={`w-8 h-8 flex items-center justify-center bg-[#ecad29]/10 rounded-full flex-shrink-0 transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`}>
                      <i className="ri-arrow-down-s-line text-[#ecad29] text-xl"></i>
                    </div>
                  </button>
                  <div 
                    className={`overflow-hidden transition-all duration-300 ${openFaq === index ? 'max-h-48' : 'max-h-0'}`}
                  >
                    <p className="px-6 pb-5 text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </article>
              ))}
            </div>
            
            <div className="mt-10 text-center">
              <p className="text-gray-500 mb-4">Başka sorularınız mı var?</p>
              <Link 
                to="/iletisim"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-[#ecad29] text-[#ecad29] rounded-full font-medium hover:bg-[#ecad29] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-question-answer-line w-5 h-5 flex items-center justify-center"></i>
                <span>Bize Sorun</span>
              </Link>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="py-6 px-4 sm:px-6 lg:px-8 bg-[#f0e6d2]">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-sm">© 2025 Adana İlkyardım Eğitim Merkezi. Tüm hakları saklıdır.</p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer nofollow"
            className="text-gray-500 text-xs hover:text-gray-700 transition-colors"
          >
            Web Design
          </a>
        </div>
      </footer>

      {/* Fixed Contact Icons */}
      <aside className="fixed bottom-6 left-6 z-[150] flex flex-col gap-3" aria-label="İletişim butonları">
        <a 
          href="https://wa.me/905324196401" 
          target="_blank" 
          rel="noopener noreferrer nofollow"
          className="w-12 h-12 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="WhatsApp ile iletişime geçin"
          aria-label="WhatsApp"
        >
          <i className="ri-whatsapp-line text-xl"></i>
        </a>
        <a 
          href="mailto:info@assaakademi.com.tr" 
          className="w-12 h-12 flex items-center justify-center bg-[#ecad29] text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="E-posta gönderin"
          aria-label="E-posta"
        >
          <i className="ri-mail-line text-xl"></i>
        </a>
        <a 
          href="tel:08503462772" 
          className="w-12 h-12 flex items-center justify-center bg-white text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer shadow-md"
          title="Bizi arayın: 0850 346 2772"
          aria-label="Telefon"
        >
          <i className="ri-phone-line text-xl"></i>
        </a>
      </aside>
    </div>
  );
}
